import * as React from "react"
import { useTranslation } from "react-i18next"

import { Allergen } from "shared/hubrise/models"

import { StyledAllergens } from "./Styles"

interface AllergensProps {
  allergens: Array<Allergen> | null
}

const Allergens = ({ allergens }: AllergensProps): JSX.Element | null => {
  const { t } = useTranslation()

  if (!allergens || allergens.length === 0) return null

  return (
    <StyledAllergens>
      {t("product.contains", {
        allergens: allergens
          .map((allergen) => t(`nutrition.allergens.${allergen}`))
          .sort((a, b) => a.localeCompare(b))
          .join(", "),
      })}
    </StyledAllergens>
  )
}

export default Allergens
